import { DONATION_DISCUSSION_TYPE } from 'types/constants';
import * as Yup from 'yup';

const validation = Yup.object({
  donationDiscussion: Yup.string().required(),
  initialApproachUserId: Yup.number()
    .nullable()
    .when('donationDiscussion', {
      is: (v) => v !== DONATION_DISCUSSION_TYPE.NO_DISCUSSION,
      then: (s) => s.required('Initial Approach By is required'),
      otherwise: (s) => s.nullable().notRequired(),
    }),
});

export default validation;
